import React from 'react';

import { SectionContentProps } from './SectionContent.interfaces';
import { useStyles } from './SectionContent.styles';

const SectionContent = ({ children, className }: SectionContentProps) => {
  const classes = useStyles();

  return <div className={`${classes.root} ${className}`}>{children}</div>;
};

export default SectionContent;
